import { slug } from "./data";

export function FilterChip({ label, isActive, onClick, color }) {
  return (
    <button
      onClick={onClick}
      className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold border transition-all duration-200 ${
        isActive ? "text-white border-transparent shadow-sm" : "bg-white text-[#334155] border-slate-200 hover:border-slate-300"
      }`}
      style={isActive ? { backgroundColor: color } : {}}
      data-testid={`filter-${slug(label)}`}
    >
      <span className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: isActive ? "#ffffff" : color }} />
      {label}
    </button>
  );
}

export function DayChip({ label, isActive, onClick, value }) {
  return (
    <button
      onClick={onClick}
      className={`rounded-full px-3.5 py-1.5 text-sm font-semibold border transition-all duration-200 ${
        isActive ? "bg-[#0EA5E9] text-white border-transparent shadow-sm" : "bg-white text-[#334155] border-slate-200 hover:border-slate-300"
      }`}
      data-testid={`day-filter-${slug(value)}`}
    >
      {label}
    </button>
  );
}
